// https://stackoverflow.com/a/73848327/2205002

const urlWithRndQueryParam = (url: string, paramName?: string) => {
  const ulrArr = url.split("#");
  const urlQry = ulrArr[0].split("?");
  const usp = new URLSearchParams(urlQry[1] || "");

  usp.set(paramName || "_z", `${Date.now()}`);
  urlQry[1] = usp.toString();
  ulrArr[0] = urlQry.join("?");

  return ulrArr.join("#");
};

const pageHardReload = async (url) => {
  const newUrl = urlWithRndQueryParam(url);

  await fetch(newUrl, {
    headers: {
      Pragma: "no-cache",
      Expires: "-1",
      "Cache-Control": "no-cache",
    },
  });

  window.location.href = url;
  // This is to ensure reload with url's having '#'
  window.location.reload();
};

export default pageHardReload;
